import { useMutation } from "./helper";
import { sendTestEmail } from "../../../api/email";

export const useSendTestEmail = () => useMutation({
    mutationFn: sendTestEmail,
});

